(function($) {

	/*
	*  render_map
	*
	*  This function will render a Google Map onto the selected jQuery element
	*
	*  @type    function
	*  @date    8/11/2013
	*  @since   4.3.0
	*
	*  @param   $el (jQuery element)
	*  @return  n/a
	*/

	function render_map( $el ) {

		// var
		var $markers = $el.find('.marker');

		// vars
		var args = {
			zoom        : 11,
			center      : new google.maps.LatLng(0, 0),
			//mapTypeId   : google.maps.MapTypeId.TERRAIN,
			mapTypeControl: true,
			mapTypeControlOptions: {
				mapTypeIds: [
					google.maps.MapTypeId.ROADMAP,
					google.maps.MapTypeId.SATELLITE
				]
			},
			styles: [
				{
					"featureType": "all",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"saturation": 36
						},
						{
							"color": "#000000"
						},
						{
							"lightness": 40
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#000000"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 17
						},
						{
							"weight": 1.2
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 29
						},
						{
							"weight": 0.2
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 18
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 19
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 17
						}
					]
				}
			]
		};



		// create map
		var map = new google.maps.Map( $el[0], args);

		// add a markers reference
		map.markers = [];

		// add markers
		$markers.each(function(){

			add_marker( $(this), map );

		});

		// center map
		center_map( map );


	}

	/*
	*  add_marker
	*
	*  This function will add a marker to the selected Google Map
	*
	*  @type    function
	*  @date    8/11/2013
	*  @since   4.3.0
	*
	*  @param   $marker (jQuery element)
	*  @param   map (Google Map object)
	*  @return  n/a
	*/
	function initialize() {

		// Create an array of styles.
		var styleArray = ('mojaMapa')[
			{
				featureType: "all",
				stylers: [
					{ saturation: -80 }
				]
			},{
				featureType: "road.arterial",
				elementType: "geometry",
				stylers: [
					{ hue: "#00ffee" },
					{ saturation: 50 }
				]
			},{
				featureType: "water",
				elementType: "geometry.fill",
				stylers: [
					{ hue: "#00ffee" },
					{ saturation: 50 },
					{ color: '#adc9b8'}
				]
			},{
				featureType: "poi.business",
				elementType: "labels",
				stylers: [
					{ visibility: "off" }
				]
			}
			];

		map.setOptions({styles: styles});

		// Create a new StyledMapType object, passing it the array of styles,
		// as well as the name to be displayed on the map type control.
		map.setOptions({styles: styles});
		// Create a map object, and include the MapTypeId to add
		// to the map type control.
		var mapOptions = {
			zoom: 11,
			center: new google.maps.LatLng(55.6468, 37.581),
			mapTypeControlOptions: {
				mapTypeIds: (google.maps.MapTypeId.TERRAIN, 'mojaMapa')
			}
		};
		var map = new google.maps.Map(document.getElementById('map-canvas'),
			mapOptions);

		//Associate the styled map with the MapTypeId and set it to display.
		map.mapTypes.set('mojaMapa', styledMap);
		map.setMapTypeId('mojaMapa');
	}

	function add_marker( $marker, map ) {

		// var
		var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

		var icon = {
			url: window.global_vars.theme_dir+"/images/ico/triangle-down.svg",
			anchor: new google.maps.Point(17,34),
			scaledSize: new google.maps.Size(34,34)
		};

		// create marker
		var marker = new google.maps.Marker({
			position    : latlng,
			map         : map,
			draggable   : false,
			icon        : icon,
			zindex      : -20
		});

		// add to array
		map.markers.push( marker );

		// if marker contains HTML, add it to an infoWindow
		if( $marker.html() )
		{
			// create info window
			var infowindow = new google.maps.InfoWindow({
				content     : $marker.html()
			});

			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', function() {

				infowindow.open( map, marker );

			});
		}

	}

	/*
	*  center_map
	*
	*  This function will center the map, showing all markers attached to this map
	*
	*  @type    function
	*  @date    8/11/2013
	*  @since   4.3.0
	*
	*  @param   map (Google Map object)
	*  @return  n/a
	*/

	function center_map( map ) {

		// vars
		var bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each( map.markers, function( i, marker ){

			var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

			bounds.extend( latlng );

		});

		// only 1 marker?
		if( map.markers.length == 1 )
		{
			// set center of map
			map.setCenter( bounds.getCenter() );
			map.setZoom( 13 );
		}
		else
		{
			// fit to bounds
			map.fitBounds( bounds );
		}

	}

	/*
	*  document ready
	*
	*  This function will render each map when the document is ready (page has loaded)
	*
	*  @type    function
	*  @date    8/11/2013
	*  @since   5.0.0
	*
	*  @param   n/a
	*  @return  n/a
	*/

	window.initMaps = function(){
		$('.acf-map').each(function(){
			render_map( $(this) );
		});
	};

	$(window).load(function(){
		if ( $('.acf-map').length ) {
			$.getScript( "https://maps.googleapis.com/maps/api/js?v=3&sensor=false&key=AIzaSyD1LdQ8qA6ctutcqJzBxHQFXNNWzGJrFqY&callback=initMaps" );
		}
	});

})(jQuery);